export default function QuoteSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    projectType: "",
    message: "",
  });
  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [honeypot, setHoneypot] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (honeypot.trim()) {
  console.log("Bot detected by honeypot");
  return;
}
    setStatus("submitting");
    try {
      const payload = new FormData();

payload.append("access_key", "3636cfed-e75d-44d4-bcfc-bdd3bfdc35d0");
payload.append("subject", "New Quote Request from Castillo Painting Website");
payload.append("from_name", "Castillo Painting Website");

Object.entries(formData).forEach(([key, value]) => {
  payload.append(key, value);
});

const res = await fetch("https://api.web3forms.com/submit", {
  method: "POST",
  body: payload,
});
        const data = await res.json();

    console.log("Web3Forms response:", data);

    if (data.success) {
      setStatus("success");
      setFormData({
        name: "",
        email: "",
        phone: "",
        projectType: "",
        message: "",
      });
    } else {
      console.error("Web3Forms error:", data);
      setStatus("error");
    }
  } catch (error) {
    console.error("Form submission error:", error);
    setStatus("error");
  }
};

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <section id="quote" className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-2xl mx-auto text-center mb-12">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-foreground-950 mb-4">
          Request a Free Quote
        </h2>
        <p className="text-foreground-600">
          Tell us about your project and we will get back to you within 24 hours.
        </p>
      </div>

      <div className="max-w-xl mx-auto">
        <form
          onSubmit={handleSubmit}
          className="bg-background-100 rounded-2xl p-6 md:p-8 space-y-5"
        >
          <div style={{ display: "none" }}>
  <input
    type="text"
    name="botcheck"
    value={honeypot}
    onChange={(e) => setHoneypot(e.target.value)}
    tabIndex={-1}
    autoComplete="off"
  />
</div>
          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-1.5">
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors"
              placeholder="Your name"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <label className="block text-sm font-medium text-foreground-700 mb-1.5">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors"
                placeholder="your@email.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground-700 mb-1.5">
                Phone
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors"
                placeholder="(555) 000-0000"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-1.5">
              Project Type
            </label>
            <select
              name="projectType"
              value={formData.projectType}
              onChange={handleChange}
              required
              className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors"
            >
              <option value="">Select a project type</option>
              <option value="interior">Interior Painting</option>
              <option value="exterior">Exterior Painting</option>
              <option value="residential">Residential</option>
              <option value="commercial">Commercial</option>
              <option value="repair">Wood / Stucco Repair</option>
              <option value="pressure">Pressure Washing</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-1.5">
              Project Details
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              maxLength={500}
              rows={4}
              className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors resize-none"
              placeholder="Tell us about your project..."
            ></textarea>
            <p className="text-xs text-foreground-400 mt-1 text-right">
              {formData.message.length}/500
            </p>
          </div>
          <button
            type="submit"
            disabled={status === "submitting"}
            className="w-full bg-primary-500 text-background-50 py-3.5 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap cursor-pointer"
          >
            {status === "submitting" ? "Submitting..." : "Submit Request"}
          </button>
          {status === "success" && (
            <p className="text-sm text-primary-600 text-center">
              Thank you! We will contact you shortly.
            </p>
          )}
          {status === "error" && (
            <p className="text-sm text-red-600 text-center">
              Something went wrong. Please try again.
            </p>
          )}
        </form>
      </div>
    </section>
  );
}
